// a simple workaround to filter out ajna by default
export const productHubDefaultFilters = {
  protocol: ['sky', 'aavev3', 'morphoblue', 'sparkv3', 'maker', 'aavev2'],
}
